import {
  Button,
  Grid,
  InputAdornment,
  SvgIcon,
  TextField
} from '@material-ui/core';
import React, { FC } from 'react';

import { Search as SearchIcon } from 'react-feather';
import { CustomKeyboardEvent } from 'src/types';

interface Props {
  keyword?: string;
  isLoading?: boolean;
  onChange?: (v: any) => void;
  onSearch?: () => void;
}

const Toolbar: FC<Props> = ({ keyword, isLoading, onChange, onSearch }) => {
  const onKeyPress = (e: CustomKeyboardEvent) => {
    if (e.key === 'Enter') {
      onSearch?.();
    }
  };

  return (
    <Grid container style={{ margin: '2em 0 1em 0', gap: '1em' }}>
      <Grid item xs={3} sm={4}>
        <TextField
          disabled={isLoading}
          fullWidth
          value={keyword}
          onChange={onChange}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SvgIcon fontSize="small" color="action">
                  <SearchIcon />
                </SvgIcon>
              </InputAdornment>
            )
          }}
          placeholder="Search PO number"
          variant="outlined"
          onKeyPress={onKeyPress}
        />
      </Grid>

      <Grid item xs={2}>
        <Button
          fullWidth
          onClick={onSearch}
          color="primary"
          variant="contained"
          style={{ height: '100%' }}
        >
          Search
        </Button>
      </Grid>
    </Grid>
  );
};

export default Toolbar;
